import React from 'react';
import { PlayIcon } from 'lucide-react';
import type { Video } from '../types/content';
type VideoCardProps = {
  video: Video;
  featured?: boolean;
};

/** YouTube-ready card. [NEED FROM ABBY: channel URL] — swap the button for an embed when available. */
export function VideoCard({
  video,
  featured = false
}: VideoCardProps) {
  return <article className="group" data-id="element-471" data-mp="1jdyxs0jlrhve">
      <button type="button" className="relative block w-full overflow-hidden bg-stone text-left" aria-label={`Play video: ${video.title} (coming soon)`} data-id="element-472" data-mp="1obqq2vo5t604">
        <img src={video.image} alt={video.imageAlt} loading="lazy" className={`w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03] ${featured ? 'aspect-video' : 'aspect-video'}`} data-id="element-473" data-mp="1sbss55xt41fx" />
        <span className="absolute inset-0 bg-charcoal/15" aria-hidden="true" data-id="element-474" data-mp="2731b4w77eok3" />
        <span aria-hidden="true" className={`absolute left-1/2 top-1/2 grid -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full border border-white/80 bg-white/90 text-charcoal transition-transform duration-200 ease-out group-hover:scale-105 ${featured ? 'h-[clamp(4rem,6vw,6.5rem)] w-[clamp(4rem,6vw,6.5rem)]' : 'h-14 w-14'}`} data-id="element-475" data-mp="2c135wedzscbe">
          <PlayIcon strokeWidth={1.25} className={featured ? 'h-6 w-6' : 'h-4 w-4'} data-id="element-476" data-mp="3ktq9d43vishk" />
        </span>
        <span className="absolute bottom-3 right-3 bg-charcoal/85 px-2 py-0.5 text-xs text-white" data-id="element-477" data-mp="leld41pj4dlu">{video.duration}</span>
      </button>
      <p className="t-label mt-4 text-[0.62rem] text-gold-deep" data-id="element-478" data-mp="ggjnsz1ifi1x">Video</p>
      <h3 className={`mt-1 font-normal text-charcoal ${featured ? 't-h3' : 'text-lg'}`} data-id="element-479" data-mp="bojp19x6ev6x">{video.title}</h3>
    </article>;
}